module.exports = __webpack_public_path__ + "static/media/Home Page Freezone.77ef4009.png";